var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.005,
    height: 13.829,
    viewBox: "0 0 15.005 13.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.018,109.426h0a1.305,1.305,0,0,1-1.3-1.3v-2.166a1.305,1.305,0,0,1,1.3-1.3h3.4l.061,0V102.5a1,1,0,0,0-1.005-1.005H1.005A1,1,0,0,0,0,102.5v9.085a1,1,0,0,0,1.005,1.005H13.471a1,1,0,0,0,1.005-1.005v-2.157l-.061,0Z",
    transform: "translate(0 -98.758)",
    fill: "#c7c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.662,219.925h-3.4a.589.589,0,0,0-.589.589v2.166a.589.589,0,0,0,.589.589h3.4a.589.589,0,0,0,.589-.589v-2.166A.589.589,0,0,0,322.662,219.925Zm-2.227,2.523a.851.851,0,1,1,.851-.851A.851.851,0,0,1,320.435,222.448Z",
    transform: "translate(-308.247 -213.316)",
    fill: "#c7c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.706,18.861a1.3,1.3,0,0,0-1.64-.825l-5.108,1.688h7.033Z",
    transform: "translate(-146.985 -17.969)",
    fill: "#c7c0c0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartWalletIcon);
export default __webpack_public_path__ + "static/media/chart-wallet-icon.635a9f24.svg";
export { ForwardRef as ReactComponent };